import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants'

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];

  constructor(private http: HttpClient) { }

  getLatestNews(newsPeriod) {
    let _latestNewsUrl = cmsApi + '/get_newsList_topX'
    let _latestNewsBody = { top: '3', month: newsPeriod }
    // console.log(_latestNewsBody);
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  getLatestNews_2(newsPeriod) {
    let _latestNewsUrl = cmsApi + '/get_newsList_topX_2'
    let _latestNewsBody = { top: '3', month: newsPeriod }
    // console.log(_latestNewsBody);
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  getSpecificNewsFromId(newsId) {
    let _specificNewsUrl = cmsApi + '/get_newsById'
    let _specificNewsBody = { newsid: newsId }
    return this.http.post(_specificNewsUrl, _specificNewsBody)
  }

  getNewsFromPeriod(newsPeriod) {
    let _getNewsPeriodUrl = cmsApi + '/get_newsList_topM'
    let _getNewsPeriodBody = { month: newsPeriod }
    // console.log(_getNewsPeriodBody)
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  changeFormatDate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }

  date_thai_dd(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day);
  }

  date_thai_mm(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (monthTh['name']);
  }

  date_thai_yy(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (year);
  }

  changeFormatDate_dd(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day;
    }
  }

  changeFormatDate_MM(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return monthTh['name'];
    }
  }

  changeFormatDate_yy(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return  year;
    }
  }

  get_announceList(isActive) {
    let _getNewsPeriodUrl = cmsApi + '/get_announceList/'
    let _getNewsPeriodBody = { IsActive: isActive,
      search: ''
     }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_eartUpdateList(isActive) {
    let _getNewsPeriodUrl = cmsApi + '/get_earthupdateList/'
    let _getNewsPeriodBody = { IsActive: isActive,
      search: ''
     }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }





}
